//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file example/testing/data.proto.
 */
export const file_example_testing_data = /*@__PURE__*/ fileDesc("ChpleGFtcGxlL3Rlc3RpbmcvZGF0YS5wcm90bxIUZXhhbXBsZS50ZXN0aW5nLmRhdGEiLgoQVGVzdEl0ZW1NdXRhdGlvbhILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAkiIAoQVGVzdExpc3RNdXRhdGlvbhIMCgRkYXRhGAEgASgJIkgKEFRlc3RJdGVtU25hcHNob3QSNAoEa2V5cxgBIAMoCzImLmV4YW1wbGUudGVzdGluZy5kYXRhLlRlc3RJdGVtTXV0YXRpb24iGwoLVGVzdFBheWxvYWQSDAoEZGF0YRgBIAEoCWIGcHJvdG8z");
/**
 * Describes the message example.testing.data.TestItemMutation.
 * Use `create(TestItemMutationSchema)` to create a new message.
 */
export const TestItemMutationSchema = /*@__PURE__*/ messageDesc(file_example_testing_data, 0);
/**
 * Describes the message example.testing.data.TestListMutation.
 * Use `create(TestListMutationSchema)` to create a new message.
 */
export const TestListMutationSchema = /*@__PURE__*/ messageDesc(file_example_testing_data, 1);
/**
 * Describes the message example.testing.data.TestItemSnapshot.
 * Use `create(TestItemSnapshotSchema)` to create a new message.
 */
export const TestItemSnapshotSchema = /*@__PURE__*/ messageDesc(file_example_testing_data, 2);
/**
 * Describes the message example.testing.data.TestPayload.
 * Use `create(TestPayloadSchema)` to create a new message.
 */
export const TestPayloadSchema = /*@__PURE__*/ messageDesc(file_example_testing_data, 3);
//# sourceMappingURL=data_pb.js.map